<template>
    <div style="display: block;width: 100%;height: 100%; position: relative">
        <template v-if="!isResized">
            <div style="width: calc(80% - 20px);height: 100%;position: absolute;left: 0;top:0">
                <div ref="container" style="display: block;width: 100%;height: 100%">
                    <div ref="sequence" class="sequence" style="margin-bottom: 10px"></div>
                </div>
            </div>
            <div style="width: 20%;height: 100%;position: absolute;right: 0;top: 0">
                <chart-legend :data="legendData" v-on:onItemMouseClick="legendMouseClick"></chart-legend>
            </div>
        </template>

    </div>
</template>

<style>
    .sequence text {
        fill: #fff;
    }

    .chart path {
        stroke: #fff;
    }
</style>

<script>
    import Vue from 'vue';
    import {getGoogleColorByString} from '@/utils/d3Utils.js'
    import SunburstChart from './sunburst-chart';
    import ChartLegend from '@/components/d3-diagram/legend/d3-legend.vue'

    import {generateid} from '@/utils/commonUtils.js'

    export default {
        name:"sunburst-chart",
        //передоваемые параметры
        props: {
            data: {
                type: Object,
                default: () => ([])
            },
            option: {
                type: Object,
                default: () => ({})
            }
        },
        // локальное состояние
        data() {
            return {
                sunburstChart: null,
                isResized: false
            }
        },
        mounted() {
            this.draw();

            let doit = null;
            window.onresize = () => {
                if (!doit) {
                    this.isResized = true;
                }

                clearTimeout(doit);
                doit = setTimeout(() => {
                    this.isResized = false;
                    doit = null;
                }, 100);
            };
        },

        computed: {
            legendData() {
                if (!this.processedData) return [];

                const self = this;

                return flatten([this.processedData]).map(({label, id}) => {
                    return {
                        id,
                        label,
                        color: getGoogleColorByString(label)
                    }
                });

                function flatten(data) {
                    let set = new Set();
                    for (let v of data) {
                        if (("undefined" !== typeof v.children && "undefined" === typeof v.children[0].children) ||
                            ("undefined" !== typeof self.option.legendDataLevel && v.level === self.option.legendDataLevel)) set.add({
                            label: v.label,
                            id: v.id
                        });
                        else
                            set = new Set([...set, ...flatten(v.children)])
                    }
                    return [...set];
                }
            },
            processedData() {
                if (!this.data) return [];

                const data = JSON.parse(JSON.stringify(this.data));

                prepocessData([data], 0);

                function prepocessData(dataset, level) {
                    for (let d of dataset) {
                        d.id = generateid();
                        d.level = level;
                        if (d.children) prepocessData(d.children, level + 1);
                    }
                }

                return data;
            },
            isLoaded() {
                return this.isResized||!this.sunburstChart
            }
        },

        //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
        methods: {
            draw() {

                $(this.$refs.container).prepend($(this.$refs.sequence).detach());

                const options = {
                    width: this.$refs.container.clientWidth,
                    height: this.$refs.container.clientHeight,
                    container: this.$refs.container,
                    sequence: this.$refs.sequence,
                    color: getGoogleColorByString
                };

                for (let i in this.option)
                    if (this.option.hasOwnProperty(i) && 'undefined' !== typeof this.option[i])
                        options[i] = this.option[i];
                this.sunburstChart = new SunburstChart(this.processedData, options);
            },

            legendMouseClick(d) {
                this.sunburstChart.selectItem(d.id);
            }
        },
        components: {ChartLegend},
        watch: {
            data() {
                this.draw();
            },
            option() {
                this.draw();
            },

            isResized(val) {
                if (!val) setTimeout(this.draw, 0);
            }
        }
    }
</script>

<style scoped>

</style>
